import React from 'react'
import PropTypes from 'prop-types'
import { getCurrencyParts } from '../../utility/formator'
import { localsMessages } from '../../utility/getTemplateData'
import AmountValidationError from '../amountValidationError.js';
import { StyleSheet, css } from 'aphrodite';
import classNames from 'classnames';
import fonts from '../../styles/fonts';
import colors from '../../styles/colors';
import * as amountUtils from './amountUtils';

const STYLES = StyleSheet.create({
	currencyString: {
		position: 'absolute',
		'font-family': fonts.ppSansSmallLight,
		'font-size': '16px',
		'line-height': '1',
		color: colors.black,
		zIndex: 1,
		top: '14px',
		left: '8px'
	},
	amountCondensed: {
		display: 'inline-block',
		margin: '0 auto',
		marginLeft: '10px'
	},
	moneyInput: {
		width: '142px',
		position: 'relative',
	},
	inputField: {
		fontFamily: fonts.ppSansSmallRegular,
		fontSize: '13px',
		paddingLeft: '18px',
		height: '46px',
	}
});

let messages = localsMessages('common/amount')

class AmountCondensed extends React.Component {
	constructor(props) {
		super(props);
		const [firstParts = {}] = getCurrencyParts()
		this.state = {
			amount: this.props.amount || '',
			symbol: this.props.symbol || '',
			code: this.props.code || '',
			rightSymbol: firstParts.$ !== 'symbol',
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.amount !== nextProps.amount) {
			this.setState({
				amount: nextProps.amount
			});
		}
	}

	setInitialValue() {
		const stringValue = amountUtils.formatAmount('');
		this.setState({ amount: stringValue });
	}

	handleFocus = (event) => {
		if (!this.state.amount) {
			this.setInitialValue();
		}
		this.props.handleAmountFocus();
	}

	handleKeyPress = (event) => {
		if (!amountUtils.isKeyAllowed(event.charCode)) {
			return;
		}
	}

	handleChange = (event) => {
		const { value } = event.target;
		if (!amountUtils.amountLengthValid(value)) {
			return;
		}
		const stringValue = amountUtils.formatAmount(value);
		this.setState({ amount: stringValue });
		this.props.handleAmount(stringValue);
	}

	// Validating on focus out causes the validation error
	// message to flash for a micro second
	// handleBlur = (event) => {
	// 	this.props.validateDonationAmount();	
	// }

	render() {
		const placeholder = messages.amount.placeholderOtherAmount;
		const amount = `${this.state.amount}`.replace(
			/[.|,]/i,
			this.props.decimalPoint
		);
		const hasError = !!this.props.showValidationError;

		return (
			<div className={`vx-form-group amount-condensed ${css(STYLES.amountCondensed)}`}>
				<div className={`${classNames('input-field', { 'vx_has-error': hasError })}`}>
					<div className={`money_input ${css(STYLES.moneyInput)} vx_form-control vx_form-control_complex`}>
						<span className={`${css(STYLES.currencyString)}`}>{this.props.symbol}</span>
						<input type="text"
							name="donationAmount"
							autoComplete="off"
							id="currencyAmount"
							placeholder={placeholder}
							pattern="[0-9]*"
							value={amount}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChange.bind(this)}
							onFocus={this.handleFocus}
							onBlur={this.handleBlur}
							className={`${css(STYLES.inputField)}`} />
						<span className="vx_form-control-error-icon vx_icon vx_icon-small vx_icon-critical-small"></span>
					</div>
				</div>

				{
					hasError && 
					<div className="vx_has-error-with-message">
						<AmountValidationError
							errorString={this.props.validationErrorMessage}
							errorSourceField={'currencyAmount'}
							donationAmount={amount}
						/>
					</div>
				}
			</div>
		);
	}
}

AmountCondensed.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	amount: PropTypes.string,
	symbol: PropTypes.string,
	code: PropTypes.string,
	decimalPoint: PropTypes.string,
	isEditable: PropTypes.bool,
	handleAmount: PropTypes.func,
	showValidationError: PropTypes.bool,
	validateDonationAmount: PropTypes.func,
	validationErrorMessage: PropTypes.string,
	handleAmountFocus: PropTypes.func
};

export default AmountCondensed



// WEBPACK FOOTER //
// ./components/amount/AmountCondensed.js